import {
  PainForm,
  RashForm,
  SwellingForm
} from 'app/components/moderations/diagnoses/versions/localized-finding-form';
import { usePopup } from 'app/hooks/utils/popup';
import { FindingType } from 'lib/models/diagnoses/choices/finding-type';
import { LocalizedFindingItem } from 'lib/models/searches/localized-findings';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { LuPlusCircle, LuUndo } from 'react-icons/lu';
import { SearchQueryProps } from '../props';

/**
 * Button to add a localized finding.
 */
export const LocalizedFindingAddButton: React.FC<{
  form: UseFormReturn<SearchQueryProps, any, undefined>;
  type: FindingType;
}> = ({ form, type }) => {
  // Enable popups support
  const { enqueuePopup } = usePopup();

  const LocalizedForm = (() => {
    if (type == FindingType.PAIN) return PainForm;
    if (type == FindingType.RASH) return RashForm;
    if (type == FindingType.SWELLING) return SwellingForm;
    throw new Error('Unsupported localized finding type');
  })();

  return (
    <button
      className="button button-ternary button-sm"
      onClick={() =>
        enqueuePopup({
          component: ({ setClosing, isClosing }) => (
            <>
              <a className="button button-secondary" onClick={setClosing}>
                <LuUndo />
                <span>Cancel</span>
              </a>
              <LocalizedForm
                isShowSensitivity={false}
                onCreated={(newItem) => {
                  setClosing();
                  const newList = [
                    ...form.getValues().localizedFindings,
                    new LocalizedFindingItem({ finding: newItem })
                  ];
                  form.setValue('localizedFindings', newList);
                }}
              />
            </>
          ),
          allowOutsideClick: false
        })
      }
    >
      <LuPlusCircle />
      <span>{type.label}</span>
    </button>
  );
};
